import React from "react";
import "./scss/table-skeleton.scss";

const TableSkeleton = ({ colSpan, rows = 3 }) => {
  return (
    <>
      {Array.from(Array(rows)).map(() => (
        <tr className="loading">
          <td colSpan={colSpan} style={{ display: "revert" }}>
            <div className="bar"></div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default TableSkeleton;
